export const ADJECTIVES = [
  '용감한', '졸린', '귀여운', '엉뚱한', '신나는', '조용한', '활발한', '느긋한',
  '호기심 많은', '재빠른', '수줍은', '당당한', '명랑한', '차분한', '씩씩한',
];

export const ANIMALS = [
  '수달', '판다', '고양이', '강아지', '토끼', '햄스터', '여우', '곰',
  '펭귄', '코알라', '너구리', '다람쥐', '물개', '돌고래', '부엉이',
  '사자', '호랑이', '기린', '코끼리', '하마', '악어', '달팽이', '뱀',
  '문어', '꿀벌', '무당벌레', '거북이', '소', '고래', '말', '원숭이',
  '돼지', '개구리', '유니콘', '독수리', '오리', '상어', '나비', '얼룩말',
  '공룡', '캥거루', '라마', '공작새', '앵무새', '백조', '플라밍고',
];

const ANIMAL_MAP: Record<string, string> = {
  '수달': 'otter',
  '판다': 'panda',
  '고양이': 'cat',
  '강아지': 'dog',
  '토끼': 'rabbit',
  '햄스터': 'hamster',
  '여우': 'fox',
  '곰': 'bear',
  '펭귄': 'penguin',
  '코알라': 'koala',
  '너구리': 'raccoon',
  '다람쥐': 'chipmunk',
  '물개': 'seal',
  '돌고래': 'dolphin',
  '부엉이': 'owl',
  '사자': 'lion',
  '호랑이': 'tiger',
  '기린': 'giraffe',
  '코끼리': 'elephant',
  '하마': 'hippo',
  '악어': 'crocodile',
  '달팽이': 'snail',
  '뱀': 'snake',
  '문어': 'octopus',
  '꿀벌': 'bee',
  '무당벌레': 'ladybug',
  '거북이': 'turtle',
  '소': 'cow',
  '고래': 'whale',
  '말': 'horse',
  '원숭이': 'monkey',
  '돼지': 'pig',
  '개구리': 'frog',
  '유니콘': 'unicorn',
  '독수리': 'eagle',
  '오리': 'duck',
  '상어': 'shark',
  '나비': 'butterfly',
  '얼룩말': 'zebra',
  '공룡': 'dinosaur',
  '캥거루': 'kangaroo',
  '라마': 'llama',
  '공작새': 'peacock',
  '앵무새': 'parrot',
  '백조': 'swan',
  '플라밍고': 'flamingo',
};

/**
 * nickname 예: "용감한 수달" → 마지막 단어를 동물로 간주하여 로컬 SVG 경로 반환
 */
export const animalAvatarUrl = (nickname?: string): string => {
  if (!nickname) return '/animals/bear.svg';
  const parts = nickname.trim().split(' ');
  const animalKo = parts[parts.length - 1];
  const animalEn = ANIMAL_MAP[animalKo] ?? 'bear';
  return `/animals/${animalEn}.svg`;
};

export const randomNickname = (): string =>
  ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)] +
  ' ' +
  ANIMALS[Math.floor(Math.random() * ANIMALS.length)];
